import React, { useRef, useState } from 'react';
import { X, Upload } from 'lucide-react';
import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export default function VehicleFormImages({ images, onChange, authHeaders }) {
  const [uploading, setUploading] = useState(false);
  const fileInputRef = useRef(null);

  const handleImageUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const allowedTypes = ['image/jpeg', 'image/png', 'image/gif', 'image/webp'];
    if (!allowedTypes.includes(file.type)) {
      alert('Type de fichier non autorisé. Utilisez JPG, PNG, GIF ou WEBP.');
      return;
    }
    if (file.size > 5 * 1024 * 1024) {
      alert("L'image est trop lourde. Maximum 5 Mo.");
      return;
    }

    setUploading(true);
    const formData = new FormData();
    formData.append('file', file);

    try {
      const response = await axios.post(`${API_URL}/api/upload`, formData, {
        headers: { ...authHeaders, 'Content-Type': 'multipart/form-data' }
      });
      onChange([...images, response.data.url]);
    } catch (error) {
      alert("Erreur lors de l'upload de l'image");
    } finally {
      setUploading(false);
      if (fileInputRef.current) fileInputRef.current.value = '';
    }
  };

  const addImageUrl = () => {
    const url = prompt("Entrez l'URL de l'image:");
    if (url) onChange([...images, url]);
  };

  const removeImage = (index) => {
    onChange(images.filter((_, i) => i !== index));
  };

  return (
    <div>
      <label className="block text-sm font-medium text-gray-700 mb-2">Photos du véhicule</label>
      <div className="flex gap-3 mb-3">
        <input
          type="file"
          ref={fileInputRef}
          onChange={handleImageUpload}
          accept="image/jpeg,image/png,image/gif,image/webp"
          className="hidden"
          data-testid="vehicle-file-input"
        />
        <button
          type="button"
          onClick={() => fileInputRef.current?.click()}
          disabled={uploading}
          className="flex items-center gap-2 px-4 py-2 bg-[#DC2626] hover:bg-red-700 text-white rounded-md transition-colors disabled:opacity-50"
          data-testid="vehicle-upload-btn"
        >
          {uploading ? (
            <><div className="spinner h-4 w-4 border-white"></div>Upload...</>
          ) : (
            <><Upload size={18} />Ajouter une photo</>
          )}
        </button>
        <button
          type="button"
          onClick={addImageUrl}
          className="px-4 py-2 border border-gray-300 text-gray-700 rounded-md hover:bg-gray-50"
        >
          Coller une URL
        </button>
      </div>
      <div className="flex flex-wrap gap-3">
        {images.map((img, index) => (
          <div key={`img-${index}`} className="relative group">
            <img src={img} alt="" className="w-24 h-24 object-cover rounded border" />
            <button
              type="button"
              onClick={() => removeImage(index)}
              className="absolute -top-2 -right-2 bg-red-500 text-white rounded-full p-1 hover:bg-red-600"
            >
              <X size={14} />
            </button>
            {index === 0 && (
              <span className="absolute bottom-1 left-1 bg-black/70 text-white text-xs px-1 rounded">Principale</span>
            )}
          </div>
        ))}
        {images.length === 0 && <p className="text-sm text-gray-500 italic">Aucune photo ajoutée</p>}
      </div>
    </div>
  );
}
